import { render, staticRenderFns } from "./womans-well-being.vue?vue&type=template&id=5e6a19c3&scoped=true&"
import script from "./womans-well-being.vue?vue&type=script&lang=js&"
export * from "./womans-well-being.vue?vue&type=script&lang=js&"
import style0 from "./womans-well-being.vue?vue&type=style&index=0&id=5e6a19c3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6a19c3",
  null
  
)

export default component.exports